import * as React from 'react';
import { Button } from 'antd';
import SideMenu from "../SideMenu/SideMenu";

import styles from './Header.module.scss';

export interface HeaderProps {
  page: string,
  reloadable: boolean,
  refresh?: () => void,
}

export interface HeaderState {
  sideMenuVisible: boolean
}

export default class Header extends React.PureComponent<HeaderProps, HeaderState> {
  public state = {
    sideMenuVisible: false
  };

  public render() {
    const { sideMenuVisible } = this.state;

    return (
      <>
        <SideMenu visible={sideMenuVisible} onClose={() => this.setState({ sideMenuVisible: false })} />
        <div className={styles.header}>
          <div>
            <Button
              className={styles.actions_button}
              size="large"
              icon="menu-unfold"
              onClick={() => this.setState({ sideMenuVisible: true })}
            />
          </div>
          <div className={styles.title}>
            <h3>{this.props.page}</h3>
          </div>
          <div>
            {this.props.reloadable &&
              <Button
                className={styles.actions_button}
                icon="reload"
                onClick={this.props.refresh}
              />}
          </div>
        </div>
      </>
    );
  }
};
